import actionCreatorFactory from 'typescript-fsa'
import { ReferralLink } from '../../api/referralLinks/types'
import { APIError } from '../../api/types'

const actionCreator = actionCreatorFactory('@@upline/referralLinks')

export const getReferralLinksActions = actionCreator.async<void, ReferralLink[], APIError>('getReferralLinks')
